module.exports = __webpack_public_path__ + "6f45ddf82b89fc889b671a143cd89251.jpg";